(function () {
    'use strict';

    var serviceId = 'paymentService';

    angular.module('app.common')
        .factory(serviceId, paymentService);

    paymentService.$inject = ['$rootScope', '$state', 'ngDialog', '$q', 'userSvc', 'notifierSvc', 'guardSvc', '$translate', 'products_factory', 'report_factory', '$ocLazyLoad'];

    function paymentService($rootScope, $state, ngDialog, $q, userSvc, notifierSvc, guardSvc, $translate, products_factory, report_factory, $ocLazyLoad) {
        var obj = {
            basket: {
                orderId: undefined,
                userId: userSvc.info.Id,
                orderDetails: {
                    "promoCode": undefined,
                    "products": [],
                    "currency": 1,
                    "installmentCount": 1,
                    "installmentType": 10
                },
                billingInformation: {
                    "addressName": undefined,
                    "name": undefined,
                    "surName": undefined,
                    "email": undefined,
                    "title": undefined,
                    "details": undefined,
                    "isCommercial": false,
                    "taxName": undefined,
                    "taxNumber": undefined,
                    "telephone": undefined,
                    "geoIds": {
                        "countryId": undefined,
                        "cityId": undefined,
                        "countyId": undefined,
                        "districtId": undefined
                    },
                    "geoNames": {
                        "countryName": "",
                        "cityName": "",
                        "countyName": "",
                        "districtName": ""
                    }
                },
                options: {
                    "activateWhenPaymentCompleted": true,
                    "paymentDueDate": undefined,
                    "discount": 0,
                    "startDate": undefined
                },
                card: {
                    "cardId": undefined,
                    "details": {
                        "holderName": "",
                        "number": "",
                        "expireMonth": "",
                        "expireYear": "",
                        "cvc": ""
                    }
                },
                paymentProcessType: 10,
            },
            idNumberValidate: idNumberValidate,
            taxNumberValidate: taxNumberValidate,
            calculatePrice: calculatePrice,
            buyElectronicReport: buyElectronicReport,
            buyReportFromPropertyDetail: buyReportFromPropertyDetail,
            buyReportFromPropertyDetailAdmin: buyReportFromPropertyDetailAdmin,
            preparePayment: preparePayment,
            getProducts: getProducts,
            getProductsForFilter: getProductsForFilter,
            addToCart: addToCart,
            clearCart: clearCart,
            changePricesByCurrency: changePricesByCurrency,
            isPreparing: false
        };


        var savedCard = localStorage.getItem('shopingCard');

        try {
            obj.basket = savedCard ? JSON.parse(savedCard) : obj.basket;
        }
        catch (err) {
            localStorage.removeItem('shopingCard');
            obj.basket = obj.basket;
        }
        return obj;


        function clearCart() {
            localStorage.removeItem('shopingCard');
            obj.basket.billingInformation = {
                "addressName": undefined,
                "name": undefined,
                "surName": undefined,
                "email": undefined,
                "title": undefined,
                "details": undefined,
                "isCommercial": false,
                "taxName": undefined,
                "taxNumber": undefined,
                "telephone": undefined,
                "geoIds": {
                    "countryId": undefined,
                    "cityId": undefined,
                    "countyId": undefined,
                    "districtId": undefined
                },
                "geoNames": {
                    "cityName": "",
                    "countyName": "",
                    "districtName": "",
                    "countryName": "Türkiye"
                }
            };
            obj.basket.orderDetails = {
                "promoCode": undefined,
                "products": [],
                "currency": 1,
                "installmentCount": 1
            };
            obj.basket.card = {};
            obj.basket.card.details = {
                cvc: undefined,
                expire: undefined,
                expireMonth: undefined,
                expireYear: undefined,
                holderName: undefined,
                number: undefined
            };
        }

        function buyElectronicReport(product, house, isRent, selectedValuation = 0, adminReport = false) {
            var deffered = $q.defer();
            if (obj.isPreparing) {
                notifierSvc.show({ title: $translate.instant('payment_edr1'), message: $translate.instant('payment_edr2'), type: "info" });
                deffered.resolve(false);
                return false;
            }
            guardSvc.hasPackage([
                "eco-package",
                'seller-lead-package',
                "premium-package",
                "premiumplus-package",
                "pro-ee-package",
                "flex-package",
                "gold-package",
                "terminal-flex-package",
                "terminal-pro-package",
                "platinum-package",
                "premium-ee-package",
                "terminal-premium-package",
                "terminal-package",
                "real-estate-package",
                "location-package",
            ]).then(function (HasPackage) {
                $ocLazyLoad.load(['/assets/css/main.payment.min.css']).then(function () {
                    ngDialog.open({
                        templateUrl: 'app/payment/edr-form.html',
                        showClose: false,
                        controller: ['$scope', '$timeout', 'LocaleService', 'endeksService', 's3Files', '$q', 'fileDragService', 'notifierSvc', '$translate', 'ngDialog', function ($scope, $timeout, LocaleService, endeksService, s3Files, $q, fileDragService, notifierSvc, $translate, ngDialog) {
                            $scope.house = house;
                            $scope.CountryId = house.CountryId;
                            $scope.userReportType = { WithDetail: HasPackage || (product.code === 'edr-commercial') };
                            $scope.HasPackage = HasPackage;
                            $scope.ValuationMethod = selectedValuation;
                            function getFileCategoryByType(file) {
                                if (file.FileType === 10) return 'image';
                                if (file.FileType === 20) return 'document';
                                return 'document';
                            }
                            function getFilesByCategory(category) {
                                return house.Files.filter(function (file) {
                                    return getFileCategoryByType(file) === category;
                                });
                            };

                            $scope.getFilesByCategory = getFilesByCategory;

                            // Initialize uploaded images and selected report files
                            $scope.uploadedImages = getFilesByCategory('image');
                            console.log($scope.uploadedImages, "uploadedImages");
                            $scope.selectedReportFiles = [];

                            // Drag & drop için state takibi - Service'ten oluşturuluyor
                            $scope.dragState = fileDragService.createDragState();
                            $scope.dragStateOverIndex = -1; // HTML'de kullanılıyor, dragState ile senkronize edilecek

                            // Log list event for dnd-draggable
                            $scope.logListEvent = function (action, index, external, type) {
                                fileDragService.logListEvent($scope.dragState, action, index, external, type);
                                $scope.dragStateOverIndex = $scope.dragState.dragStateOverIndex; // HTML için senkronize et
                            };

                            // Re-sort images for report - Service'ten çağrılıyor
                            $scope.reSortReportImages = function () {
                                var docList = getFilesByCategory('document');
                                fileDragService.reSortFiles($scope.uploadedImages, docList, function (files) {
                                    // Update house.Files
                                    $scope.house.Files = files;

                                    // Save to backend
                                    endeksService.changeFiles($scope.house.Id, files).then(function () {
                                        // Update uploadedImages after re-sort
                                        $scope.uploadedImages = files.filter(function (file) {
                                            return file.FileType === 10;
                                        });
                                    });
                                });
                            };

                            // Remove image from report
                            // Url bazlı karşılaştırma - Id henüz olmayabilir
                            $scope.removeReportImage = function (imageUrl) {
                                var index = $scope.house.Files.findIndex(function (file) {
                                    return file.Url === imageUrl;
                                });
                                if (index > -1) {
                                    $scope.house.Files.splice(index, 1);
                                    // Update uploadedImages after removal
                                    $scope.uploadedImages = getFilesByCategory('image');
                                    // Save to backend
                                    endeksService.changeFiles($scope.house.Id, $scope.house.Files);
                                }
                            };

                            // Confirm delete image
                            // Url bazlı karşılaştırma - Id henüz olmayabilir
                            $scope.confirmDeleteImage = function (imageUrl) {
                                ngDialog.openConfirm({
                                    template: '\
                                        <div class="modal-content modal-action-wrapper padding-10">\
                                            <div class="modal-body">\
                                                <div class="dark">\
                                                    <p><i class="ei-trash" style="color: #FF0550;"></i></p>\
                                                    <h4 translate="confirm_delete_image">Fotoğrafı silmek istediğinize emin misiniz?</h4>\
                                                </div>\
                                                <p class="text-center margin-top-40">\
                                                    <button ng-click="confirm()" type="button" class="btn btn-danger btn-md">\
                                                        <i class="ei-trash"></i>&nbsp;<span translate="delete">Sil</span>\
                                                    </button>\
                                                    <button ng-click="closeThisDialog()" type="button" class="btn btn-default btn-md">\
                                                        <span translate="cancel">Vazgeç</span>\
                                                    </button>\
                                                </p>\
                                            </div>\
                                        </div>',
                                    plain: true,
                                    className: 'ngdialog-theme-default',
                                    scope: $scope
                                }).then(function () {
                                    $scope.removeReportImage(imageUrl);
                                });
                            };

                            // Toggle image selection for report
                            $scope.toggleImageSelection = function (image) {
                                // Url bazlı karşılaştırma - Id henüz olmayabilir
                                var index = $scope.selectedReportFiles.findIndex(function (file) {
                                    return file.Url === image.Url;
                                });

                                if (index > -1) {
                                    $scope.selectedReportFiles.splice(index, 1);
                                } else {
                                    // Maksimum 6 resim seçilebilir
                                    if ($scope.selectedReportFiles.length >= 6) {
                                        notifierSvc.error($translate.instant('max_6_images_error'));
                                        return;
                                    }
                                    $scope.selectedReportFiles.push(image);
                                }
                            };

                            // Check if image is selected
                            $scope.isImageSelected = function (image) {
                                // Url bazlı karşılaştırma - Id henüz olmayabilir
                                return $scope.selectedReportFiles.some(function (file) {
                                    return file.Url === image.Url;
                                });
                            };

                            $scope.CoverImageType = 20;
                            $scope.PersonalMessage = null;
                            $scope.DedicationNote = null;
                            $scope.usePropertyNote = false;

                            // Capitalize first letter of each word (Turkish locale-aware)
                            $scope.capitalizeDedicationNote = function () {
                                if ($scope.DedicationNote) {
                                    // Use Turkish locale for proper i/İ and I/ı handling
                                    $scope.DedicationNote = $scope.DedicationNote
                                        .toLocaleLowerCase('tr-TR')
                                        .replace(/(?:^|\s)\S/g, function (char) {
                                            return char.toLocaleUpperCase('tr-TR');
                                        });
                                }
                            };

                            // Property note toggle
                            $scope.propertyNote = house.Note || '';
                            $scope.togglePropertyNote = function () {
                                // Toggle the checkbox manually
                                $scope.usePropertyNote = !$scope.usePropertyNote;

                                // Update the message based on new state
                                if ($scope.usePropertyNote) {
                                    // Limit to 1000 characters
                                    $scope.PersonalMessage = $scope.propertyNote.substring(0, 1000);
                                } else {
                                    $scope.PersonalMessage = '';
                                }
                            };

                            // Select uploaded cover image
                            $scope.selectUploadedCover = function () {
                                if ($scope.uploadedImages && $scope.uploadedImages.length > 0) {
                                    $scope.CoverImageType = 30;
                                } else {
                                    notifierSvc.show({ message: $translate.instant('cover_uploaded_no_image_warning'), type: "warning" });
                                    $scope.CoverImageType = 20;
                                }
                            };

                            // Open photo upload modal
                            $scope.openPhotoUploadModal = function () {
                                ngDialog.open({
                                    templateUrl: 'app/endeks/modal-photo-upload.html',
                                    scope: $scope,
                                    closeByDocument: false,
                                    closeByEscape: true,
                                    className: 'ngdialog-theme-default custom-photo-upload-modal',
                                    controller: [
                                        '$scope', '$window', '$timeout', 'notifierSvc', 's3Files', 'endeksService', '$q', '$translate',
                                        function ($scope, $window, $timeout, notifierSvc, s3Files, endeksService, $q, $translate) {

                                            // Modal scope değişkenleri
                                            $scope.onlyImage = true;
                                            $scope.selectedFiles = [];
                                            $scope.totalSize = 0;
                                            $scope.uploadProgress = 0;
                                            $scope.isUploading = false;
                                            $scope.isDragOver = false;

                                            // Güvenli $apply fonksiyonu
                                            $scope.safeApply = function (fn) {
                                                var phase = $scope.$root.$$phase;
                                                if (phase === '$apply' || phase === '$digest') {
                                                    if (fn && typeof fn === 'function') {
                                                        fn();
                                                    }
                                                } else {
                                                    $scope.$apply(fn);
                                                }
                                            };

                                            // Dosya seçme fonksiyonu
                                            $scope.triggerFileInput = function () {
                                                $timeout(function () {
                                                    var fileInput = document.getElementById('photo-file-input');
                                                    if (fileInput) {
                                                        // Input'un value'sunu temizle (aynı dosya tekrar seçilebilsin diye)
                                                        fileInput.value = '';
                                                        fileInput.click();
                                                    }
                                                }, 0);
                                            };

                                            // Dosya seçim handler
                                            $scope.handleFileSelect = function (files) {
                                                debugger;
                                                for (var i = 0; i < files.length; i++) {
                                                    var file = files[i];
                                                    if ($scope.validateFile(file)) {
                                                        $scope.addFileToList(file);
                                                    }
                                                }
                                                $scope.safeApply();
                                            };

                                            // Drag & Drop handlers
                                            $scope.handleDragOver = function (event) {
                                                event.preventDefault();
                                                event.stopPropagation();
                                                $scope.isDragOver = true;
                                                $scope.safeApply();
                                            };

                                            $scope.handleDragLeave = function (event) {
                                                event.preventDefault();
                                                event.stopPropagation();
                                                $scope.isDragOver = false;
                                                $scope.safeApply();
                                            };

                                            $scope.handleDrop = function (event) {
                                                debugger;
                                                event.preventDefault();
                                                event.stopPropagation();
                                                $scope.isDragOver = false;

                                                var files = event.dataTransfer.files;
                                                $scope.handleFileSelect(files);
                                            };

                                            // Dosya validasyonu
                                            $scope.validateFile = function (file) {
                                                debugger;
                                                // Desteklenen dosya türleri
                                                var supportedTypes = [
                                                    // Images
                                                    'image/jpeg', 'image/jpg', 'image/png', 'image/gif',
                                                ];

                                                // Dosya türü kontrolü
                                                if (supportedTypes.indexOf(file.type) === -1) {
                                                    notifierSvc.show({ message: $translate.instant('file_type_not_supported'), type: "error" });
                                                    return false;
                                                }

                                                // Dosya boyutu kontrolü (5MB)
                                                if (file.size > 5 * 1024 * 1024) {
                                                    notifierSvc.show({ message: $translate.instant('file_size_too_large'), type: "error" });
                                                    return false;
                                                }

                                                // Aynı dosya kontrolü (orijinal boyut ile karşılaştır)
                                                for (var i = 0; i < $scope.selectedFiles.length; i++) {
                                                    var existingFile = $scope.selectedFiles[i];
                                                    var existingSize = existingFile.originalSize || existingFile.size;
                                                    if (existingFile.name === file.name && existingSize === file.size) {
                                                        notifierSvc.show({ message: $translate.instant('file_already_selected'), type: "warning" });
                                                        return false;
                                                    }
                                                }

                                                return true;
                                            };

                                            $scope.resizeImageIfNeeded = function (dataUrl, fileName) {
                                                return new Promise(function (resolve, reject) {
                                                    var img = new Image();
                                                    img.onload = function () {
                                                        var canvas = document.createElement('canvas');
                                                        var ctx = canvas.getContext('2d');

                                                        var originalWidth = img.width;
                                                        var originalHeight = img.height;

                                                        // Yeni boyutları hesapla
                                                        var newWidth = originalWidth;
                                                        var newHeight = originalHeight;
                                                        var needsResize = false;

                                                        // Width kontrolü
                                                        if (originalWidth > 1200) {
                                                            newWidth = 1200;
                                                            newHeight = (originalHeight * 1200) / originalWidth;
                                                            needsResize = true;
                                                        }

                                                        // Height kontrolü (width resize sonrası yeni height'ı kontrol et)
                                                        if (newHeight > 600) {
                                                            var oldHeight = newHeight;
                                                            newHeight = 600;
                                                            newWidth = (newWidth * 600) / oldHeight;
                                                            needsResize = true;
                                                        }

                                                        if (!needsResize) {
                                                            resolve(dataUrl);
                                                            return;
                                                        }

                                                        // Canvas boyutlarını ayarla
                                                        canvas.width = Math.round(newWidth);
                                                        canvas.height = Math.round(newHeight);

                                                        // Resmi yeniden boyutlandır ve çiz
                                                        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                                                        // Yeni data URL'i oluştur
                                                        var resizedDataUrl = canvas.toDataURL('image/jpeg', 0.85);

                                                        console.log('Resim boyutlandırıldı:', fileName);
                                                        console.log('Orijinal:', originalWidth + 'x' + originalHeight);
                                                        console.log('Yeni:', canvas.width + 'x' + canvas.height);

                                                        resolve(resizedDataUrl);
                                                    };

                                                    img.onerror = function () {
                                                        console.error('Resim yüklenirken hata oluştu:', fileName);
                                                        resolve(dataUrl); // Hata durumunda orijinal dosyayı kullan
                                                    };

                                                    img.src = dataUrl;
                                                });
                                            };

                                            $scope.calculateBase64Size = function (base64String) {
                                                var stringLength = base64String.length - 'data:image/jpeg;base64,'.length;
                                                var sizeInBytes = 4 * Math.ceil(stringLength / 3) * 0.5624896334383812;
                                                return Math.round(sizeInBytes);
                                            };

                                            // Dosya listesine ekle
                                            $scope.addFileToList = function (file) {

                                                var reader = new FileReader();
                                                reader.onload = function (e) {
                                                    $scope.resizeImageIfNeeded(e.target.result, file.name).then(function (resizedDataUrl) {
                                                        var fileObject = {
                                                            name: file.name,
                                                            size: $scope.calculateBase64Size(resizedDataUrl),
                                                            type: file.type,
                                                            category: 'image',
                                                            preview: resizedDataUrl,
                                                            file: file,
                                                            originalSize: file.size,
                                                            resized: resizedDataUrl !== e.target.result
                                                        };
                                                        $scope.selectedFiles.push(fileObject);
                                                        $scope.totalSize += fileObject.size;
                                                        $scope.safeApply();
                                                    });
                                                };
                                                reader.readAsDataURL(file);
                                            };

                                            // Dosya objesi ile silme
                                            $scope.removeFileByObject = function (fileToRemove) {
                                                for (var i = 0; i < $scope.selectedFiles.length; i++) {
                                                    if ($scope.selectedFiles[i] === fileToRemove) {
                                                        $scope.totalSize -= fileToRemove.size;
                                                        $scope.selectedFiles.splice(i, 1);
                                                        // Input'un value'sunu temizle (aynı dosya tekrar seçilebilsin diye)
                                                        var fileInput = document.getElementById('photo-file-input');
                                                        if (fileInput) {
                                                            fileInput.value = '';
                                                        }
                                                        $scope.safeApply();
                                                        break;
                                                    }
                                                }
                                            };

                                            // Dosya boyutunu formatla
                                            $scope.formatFileSize = function (bytes) {
                                                if (bytes === 0) return '0 Bytes';
                                                var k = 1024;
                                                var sizes = ['Bytes', 'KB', 'MB', 'GB'];
                                                var i = Math.floor(Math.log(bytes) / Math.log(k));
                                                return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
                                            };

                                            // Dosyaları yükle
                                            $scope.uploadFiles = function () {
                                                if ($scope.selectedFiles.length === 0) {
                                                    notifierSvc.show({ message: $translate.instant('please_select_at_least_one_file'), type: "warning" });
                                                    return;
                                                }

                                                $scope.isUploading = true;
                                                $scope.uploadProgress = 0;

                                                var uploadPromises = [];

                                                for (var i = 0; i < $scope.selectedFiles.length; i++) {
                                                    var file = $scope.selectedFiles[i];
                                                    uploadPromises.push($scope.uploadSingleFile(file, i, $scope.selectedFiles[i].category));
                                                }

                                                $q.all(uploadPromises).then(
                                                    function (results) {
                                                        var successCount = 0;
                                                        var newFiles = [];

                                                        results.forEach(function (result, i) {
                                                            if (result.success) {
                                                                successCount++;
                                                                newFiles.push({
                                                                    Id: null,
                                                                    Url: result.url,
                                                                    FileOrder: i,
                                                                    FileType: 10
                                                                });
                                                            }
                                                        });

                                                        if (successCount > 0) {
                                                            // Parent scope'dan house'a erişim ve güncelleme
                                                            if (!$scope.$parent.house.Files) {
                                                                $scope.$parent.house.Files = [];
                                                            }
                                                            var allFiles = $scope.$parent.house.Files.concat(newFiles);

                                                            endeksService.changeFiles($scope.$parent.house.Id, allFiles).then(
                                                                function () {
                                                                    $scope.$parent.house.Files = angular.copy(allFiles);
                                                                    notifierSvc.show({
                                                                        message: $translate.instant('files_uploaded_success', { count: successCount }),
                                                                        type: "success"
                                                                    });

                                                                    // Uploaded images listesini güncelle
                                                                    var updatedFiles = $scope.$parent.house.Files || [];
                                                                    $scope.$parent.uploadedImages = updatedFiles.filter(function (file) {
                                                                        return file.FileType === 10;
                                                                    });
                                                                    $scope.closeThisDialog();
                                                                },
                                                                function (err) {
                                                                    var msg = err.data.Message || $translate.instant('files_uploaded_db_error');
                                                                    if (msg.includes('Maximum file limit')) {
                                                                        msg = $translate.instant('files_uploaded_max_error');
                                                                    }
                                                                    notifierSvc.show({
                                                                        message: msg,
                                                                        type: "error"
                                                                    });
                                                                }
                                                            );
                                                        } else {
                                                            notifierSvc.show({ message: $translate.instant('no_files_uploaded'), type: "error" });
                                                        }

                                                        $scope.isUploading = false;
                                                        $scope.uploadProgress = 0;
                                                    },
                                                    function (error) {
                                                        $scope.isUploading = false;
                                                        $scope.uploadProgress = 0;
                                                        notifierSvc.show({ message: $translate.instant('upload_error'), type: "error" });
                                                    }
                                                );
                                            };

                                            // Tek dosya yükleme
                                            $scope.uploadSingleFile = function (fileObj, index) {
                                                return new Promise(function (resolve, reject) {

                                                    function performUpload(base64Data) {
                                                        var object = {
                                                            "FileName": fileObj.name,
                                                            "Path": "properties/" + $scope.$parent.house.Id,
                                                        };
                                                        var uploadReq = null;

                                                        object.ImageBase64 = base64Data;
                                                        uploadReq = s3Files.uploadImg().query(object);

                                                        uploadReq.$promise.then(function (data) {
                                                            $scope.uploadProgress = ((index + 1) / $scope.selectedFiles.length) * 100;
                                                            $scope.safeApply();
                                                            resolve({ success: true, url: fileObj.category === 'image' ? data.ImageUrl : data.FileUrl, type: fileObj.category });
                                                        }).catch(function (error) {
                                                            resolve({ success: false, error: error });
                                                        });
                                                    }

                                                    // Eğer resim dosyası ise zaten preview var

                                                    performUpload(fileObj.preview);

                                                });
                                            };
                                        }
                                    ]
                                });
                            };

                            $scope.reportFeatures = {
                                "About": true,
                                "Certificates": true,
                                "TrendGraph": true,
                                "Comparables": true,
                                "LongtimeComparables": true,
                                "ShorttimeComparables": true,
                                "ComparablesSort": true,
                                "Demography": true,
                                "Expenses": true,
                                "Locations": true,
                                "ForSale": true,
                                "ForRent": true,
                                "Elections": true,
                                RiskLandG1: true,
                                //FidLandAttribute: true,
                                RiskLandForest: true,
                                RiskLandAgriculture: true,
                                RiskEnh: false,
                                //Enh: false,
                                RiskTransformer: false,
                                RiskFloodRiverNetwork: false,
                                FloodAttribute: false,
                                LandslideCode: false,
                                PGA10: false
                            };
                            $scope.reportFeaturesBasic = {
                                "TrendGraph": true,
                                "Comparables": true,
                                "Demography": true,
                                "Elections": true,
                            };
                            var sliceIndex = 12;
                            if ($scope.CountryId !== 1) {
                                delete $scope.reportFeatures["Demography"];
                                delete $scope.reportFeatures["Elections"];
                                delete $scope.reportFeatures["Expenses"];
                                delete $scope.reportFeatures["Locations"];
                                delete $scope.reportFeatures["RiskLandG1"];
                                delete $scope.reportFeatures["RiskLandForest"];
                                delete $scope.reportFeatures["RiskLandAgriculture"];
                                delete $scope.reportFeatures["RiskEnh"];
                                delete $scope.reportFeatures["RiskTransformer"];
                                delete $scope.reportFeatures["RiskFloodRiverNetwork"];
                                delete $scope.reportFeatures["FloodAttribute"];
                                delete $scope.reportFeatures["LandslideCode"];
                                // delete $scope.reportFeatures["ComparablesSort"];
                                // delete $scope.reportFeatures["LongtimeComparables"];
                                // delete $scope.reportFeatures["ShorttimeComparables"];
                                delete $scope.reportFeaturesBasic["Demography"];
                                delete $scope.reportFeaturesBasic["Elections"];
                                sliceIndex = 10;
                                if (selectedValuation === 30) {
                                    delete $scope.reportFeatures["Comparables"];
                                    delete $scope.reportFeaturesBasic["Comparables"];
                                }
                            } else {
                                if (selectedValuation === 30) {
                                    delete $scope.reportFeatures["Comparables"];
                                    delete $scope.reportFeaturesBasic["Comparables"];
                                }
                            }
                            var reportFeaturesKeys = Object.keys($scope.reportFeatures);
                            var reportFeaturesProfileLeftIndexFirst = reportFeaturesKeys.indexOf("About");
                            var reportFeaturesProfileLeftIndexLast = reportFeaturesKeys.indexOf("Certificates");
                            $scope.reportFeaturesProfileLeftCol = reportFeaturesKeys.slice(reportFeaturesProfileLeftIndexFirst, reportFeaturesProfileLeftIndexLast).reduce((result, key) => {
                                result[key] = $scope.reportFeatures[key];
                                return result;
                            }, {});
                            var reportFeaturesProfileRightIndexFirst = reportFeaturesKeys.indexOf("Certificates");
                            var reportFeaturesProfileRightIndexLast = reportFeaturesKeys.indexOf("TrendGraph");
                            $scope.reportFeaturesProfileRightCol = reportFeaturesKeys.slice(reportFeaturesProfileRightIndexFirst, reportFeaturesProfileRightIndexLast).reduce((result, key) => {
                                result[key] = $scope.reportFeatures[key];
                                return result;
                            }, {});
                            var reportFeaturesComparableIndexFirst = reportFeaturesKeys.indexOf("TrendGraph");
                            var reportFeaturesComparableIndexLast = reportFeaturesKeys.indexOf("ShorttimeComparables");
                            $scope.reportFeaturesComparableLeftCol = reportFeaturesKeys.slice(reportFeaturesComparableIndexFirst, reportFeaturesComparableIndexLast).reduce((result, key) => {
                                result[key] = $scope.reportFeatures[key];
                                return result;
                            }, {});
                            var reportFeaturesComparableRightIndexFirst = reportFeaturesKeys.indexOf("ShorttimeComparables");
                            var reportFeaturesComparableRightIndexLast = reportFeaturesKeys.indexOf("Demography");
                            $scope.reportFeaturesComparableRightCol = reportFeaturesKeys.slice(reportFeaturesComparableRightIndexFirst, reportFeaturesComparableRightIndexLast).reduce((result, key) => {
                                result[key] = $scope.reportFeatures[key];
                                return result;
                            }, {});
                            var reportFeaturesLocationLeftIndexFirst = reportFeaturesKeys.indexOf("Demography");
                            var reportFeaturesLocationLeftIndexLast = reportFeaturesKeys.indexOf("ForSale");
                            $scope.reportFeaturesLocationLeftCol = reportFeaturesKeys.slice(reportFeaturesLocationLeftIndexFirst, reportFeaturesLocationLeftIndexLast).reduce((result, key) => {
                                result[key] = $scope.reportFeatures[key];
                                return result;
                            }, {});
                            var reportFeaturesLocationRightIndexFirst = reportFeaturesKeys.indexOf("ForSale");
                            var reportFeaturesLocationRightIndexLast = reportFeaturesKeys.indexOf("RiskLandG1");
                            $scope.reportFeaturesLocationRightCol = reportFeaturesKeys.slice(reportFeaturesLocationRightIndexFirst, reportFeaturesLocationRightIndexLast).reduce((result, key) => {
                                result[key] = $scope.reportFeatures[key];
                                return result;
                            }, {});
                            var reportFeaturesRiskLeftIndexFirst = reportFeaturesKeys.indexOf("RiskLandG1");
                            var reportFeaturesRiskLeftIndexLast = reportFeaturesKeys.indexOf("RiskFloodRiverNetwork");
                            $scope.reportFeaturesRiskLeftCol = reportFeaturesKeys.slice(reportFeaturesRiskLeftIndexFirst, reportFeaturesRiskLeftIndexLast).reduce((result, key) => {
                                result[key] = $scope.reportFeatures[key];
                                return result;
                            }, {});
                            var reportFeaturesRiskRightIndexFirst = reportFeaturesKeys.indexOf("RiskFloodRiverNetwork");
                            var reportFeaturesRiskRightIndexLast = reportFeaturesKeys.length;
                            $scope.reportFeaturesRiskRightCol = reportFeaturesKeys.slice(reportFeaturesRiskRightIndexFirst, reportFeaturesRiskRightIndexLast).reduce((result, key) => {
                                result[key] = $scope.reportFeatures[key];
                                return result;
                            }, {});
                            $scope.selectedReportFeatures = angular.copy($scope.reportFeatures);
                            $scope.selectedReportFeaturesBasic = angular.copy($scope.reportFeaturesBasic);

                            // Wizard Control
                            $scope.wizardStep = 1;

                            $scope.nextStep = function () {
                                if ($scope.wizardStep < 2) {
                                    $scope.wizardStep++;
                                }
                            };

                            $scope.prevStep = function () {
                                if ($scope.wizardStep > 1) {
                                    $scope.wizardStep--;
                                }
                            };

                            var Lang = window.lang;
                            var language = 1;
                            $scope.isRent = isRent;


                            $scope.code = product.code;
                            switch (Lang) {
                                case 'tr':
                                    $scope.currentDisplayName = 'Türkçe';
                                    language = 1;
                                    break;
                                case 'en':
                                    $scope.currentDisplayName = 'English';
                                    language = 2;
                                    break;
                                case 'es-ES':
                                    $scope.currentDisplayName = 'Español';
                                    language = 3;
                                    break;
                                case 'pt-PT':
                                    $scope.currentDisplayName = 'Português';
                                    language = 4;
                                    break;
                            }
                            $scope.localesDisplayNames = LocaleService.getLocalesDisplayNames();
                            $scope.localesExcludedCountries = $scope.localesDisplayNames.filter(n => n === 'Türkçe' || n === 'English');

                            $scope.visible = $scope.localesDisplayNames && $scope.localesDisplayNames.length > 1;

                            $scope.addFlag = function (localeDisplayName) {
                                var flag;
                                switch (localeDisplayName) {
                                    case 'Türkçe':
                                        flag = 'tr';
                                        break;
                                    case 'English':
                                        flag = 'us';
                                        break;
                                    case 'Español':
                                        flag = 'es';
                                        break;
                                    case 'Português':
                                        flag = 'pt';
                                        break;
                                    default:
                                        flag = 'tr';
                                }
                                return flag;
                            };

                            $scope.changeLanguage = function (locale) {
                                var localeKey;
                                console.log("changeLanguage", locale);
                                if (locale === 'Türkçe') {
                                    localeKey = 'tr';
                                    language = 1;
                                } else if (locale === 'English') {
                                    localeKey = 'en';
                                    language = 2;
                                } else if (locale === 'Español') {
                                    localeKey = 'es';
                                    language = 3;
                                } else if (locale === 'Português') {
                                    localeKey = 'pt';
                                    language = 4;
                                }
                                Lang = localeKey;
                            };
                            $scope.handleReportTypeClick = function () {
                                if (product.code === 'edr-commercial') {
                                    return;
                                }
                                if (HasPackage) {
                                    $scope.userReportType.WithDetail = true;
                                } else {
                                    $scope.userReportType.WithDetail = false;
                                }
                            };
                            $scope.accept = function () {
                                ngDialog.open({
                                    templateUrl: 'app/payment/payment-edr-modal.html'
                                });
                                obj.isPreparing = true;
                                var order = {
                                    TasinmazId: house.Id,
                                    ProductId: product.id.value,
                                    Lang: Lang,
                                    Language: language,
                                    IsRent: isRent,
                                    UserId: adminReport ? house.CreatorId : userSvc.info.Id,
                                    WithDetail: $scope.userReportType.WithDetail,
                                    CurrencyId: window.currencyEndeksaCode(window.currency),
                                    ReportFeatures: $scope.userReportType.WithDetail ? $scope.selectedReportFeatures : $scope.selectedReportFeaturesBasic,
                                    CoverImageType: $scope.CoverImageType || 10,
                                    PersonalMessage: $scope.PersonalMessage || '',
                                    DedicationNote: $scope.DedicationNote || '',
                                    ReportFiles: $scope.selectedReportFiles
                                };
                                console.log("order", order);

                                var orderResult = adminReport ? report_factory.getReportAdmin(order) : report_factory.getReport(order);
                                orderResult.$promise.then(function (response) {
                                    if (angular.isDefined(response.Data)) {
                                        $rootScope.showAdv = false;
                                        // $analytics.eventTrack('Downloading Report', {
                                        //     category: 'Report Download',
                                        //     nonInteraction: true,
                                        //     page: $location.path()
                                        // });
                                        ngDialog.close();
                                        obj.isPreparing = false;
                                        if (response.Error === true) {
                                            deffered.reject({ message: response.Description, type: "error" });
                                        }
                                        deffered.resolve(true);
                                    }
                                    else {
                                        ngDialog.close();
                                        obj.isPreparing = false;
                                        notifierSvc.show({ message: response.Message, type: "error" });
                                        deffered.resolve(false);
                                    }
                                }, function (response) {
                                    var message;
                                    if (response.Message) {
                                        message = response.Message;
                                    } else if (response.data && response.data.Message && response.data.Message.includes("only allows plain text")) {
                                        message = 'plain_text_error';
                                    } else if (response.data && response.data.Message) {
                                        message = response.data.Message;
                                    }
                                    if (message.indexOf('not EDR credit') !== -1) {
                                        message = 'payment_no_credit';
                                    }
                                    ngDialog.close();
                                    obj.isPreparing = false;
                                    notifierSvc.show({ message: $translate.instant(message), type: "error" });
                                    deffered.resolve(false);
                                });
                            };

                        }]
                    });
                });
            });
            return deffered.promise;
        }

        function calculatePrice(promoCode) {
            obj.basket.orderDetails.promoCode = promoCode;
            localStorage.setItem('shopingCard', JSON.stringify(obj.basket));
        }


        function taxNumberValidate(taxno) {
            if (taxno) {
                var taxStr = (taxno !== null && taxno !== undefined) ? taxno.toString() : '';
                var _error = false;
                var message = '';
                if (taxStr.length < 10 || taxStr.length > 11) {
                    _error = true;
                    message = $translate.instant('onepage_new_error13');
                };
                /* if (!window.isTaxNoValid(taxno.toString())) {
                    _error = true;
                    message = $translate.instant('onepage_new_error13');
                } */
                return {
                    'error': _error,
                    'message': message
                };
            }
            else
                return {
                    'error': true,
                    'message': ''
                };
        }


        function idNumberValidate(tckimlikno) {
            var _error = false;
            var message = '';
            if (!tckimlikno || !window.checkTcNum(tckimlikno)) {
                _error = true;
                message = "Geçerli bir kimlik numarası giriniz.";
            }
            if (tckimlikno && tckimlikno.length !== 11) {
                message = "TC kimlik numaranız 11 haneli olmalıdır.";
            }
            return {
                'error': _error,
                'message': message
            };
        }

        function makeReadyForPayment(product) {
            $state.go('odeme-onepage', { code: product.code, langcode: $rootScope.lang });
        }


        function preparePayment(product) {
            var langcode = window.lang || 'tr';
            $state.go('odeme-onepage', { langcode: langcode, code: product.code, ad: $rootScope.ad, promo: product.promo });
        }

        function addToCart(product) {
            obj.basket.orderDetails.products.push(product);
            window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            window.dataLayer.push({
                event: "add_to_cart",
                currency: window.currency,
                language: window.lang.split('-')[0],
                ecommerce: {
                    currency: window.currency,
                    currencyCode: window.currency,
                    items: [
                        {
                            "id": product.id.value,
                            "name": product.nameEnglish,
                            "brand": "Endeksa",
                            "category": product.productType === 10 ? 'Report' : product.productType === 40 ? 'Monthly Package' : product.productType === 20 ? 'Annual Package' : 'Other',
                            "sku": product.code,
                            "quantity": 1,
                            "price": product.productType === 40 ? product.monthlyPrice : product.productType === 20 ? product.yearlyPrice : product.singlePrice
                        }
                    ]
                }
            });
            // $window.gtag('event', 'add_to_cart', {
            //     "items": [
            //         {
            //             "id": product.id.value,
            //             "name": product.nameEnglish,
            //             "brand": "Endeksa",
            //             "category": product.productType === 10 ? 'Report' : product.productType === 40 ? 'Monthly Package' : product.productType === 20 ? 'Annual Package' : 'Other',
            //             "sku": product.code,
            //             "quantity": 1,
            //             "price": product.productType === 40 ? product.monthlyPrice : product.productType === 20 ? product.yearlyPrice : product.singlePrice
            //         }
            //     ]
            // });
            localStorage.setItem('shopingCard', JSON.stringify(obj.basket));
        }

        function buyReportFromPropertyDetail(product, house, valuation, isRent) {
            var deferred = $q.defer();
            var EDRPermission = guardSvc.checkCreditValue('edr-house');
            var EDRLandPermission = guardSvc.checkCreditValue('edr-plot');
            var EDRFieldPermission = guardSvc.checkCreditValue('edr-land');
            var EDRCommercialPermission = guardSvc.checkCreditValue('edr-commercial');
            var score = isRent ? valuation.QualityControlScoreRent : valuation.QualityControlScore;
            if (product.code === 'edr-house' && EDRPermission) {
                if (score >= 50) {
                    obj.buyElectronicReport(product, house, isRent, valuation.ValuationMethod).then(function (refresh) {
                        deferred.resolve(refresh);
                    }).catch(e => {
                        deferred.reject(e);
                    });
                } else {
                    ngDialog.open({
                        templateUrl: 'app/endeks/modal-edr-star-error.html'
                    });
                    deferred.resolve(false);
                }
            } else if (product.code === 'edr-plot' && EDRLandPermission) {
                if (score >= 50) {
                    obj.buyElectronicReport(product, house, isRent).then(function (refresh) {
                        deferred.resolve(refresh);
                    }).catch(e => {
                        deferred.reject(e);
                    });
                } else {
                    ngDialog.open({
                        templateUrl: 'app/endeks/modal-edr-star-error.html'
                    });
                    deferred.resolve(false);
                }
            } else if (product.code === 'edr-land' && EDRFieldPermission) {
                if (score >= 50) {
                    obj.buyElectronicReport(product, house, isRent).then(function (refresh) {
                        deferred.resolve(refresh);
                    }).catch(e => {
                        deferred.reject(e);
                    });
                } else {
                    ngDialog.open({
                        templateUrl: 'app/endeks/modal-edr-star-error.html'
                    });
                    deferred.resolve(false);
                }
            } else if (product.code === 'edr-commercial' && EDRCommercialPermission) {
                if (score >= 50) {
                    obj.buyElectronicReport(product, house, isRent).then(function (refresh) {
                        deferred.resolve(refresh);
                    }).catch(e => {
                        deferred.reject(e);
                    });
                } else {
                    ngDialog.open({
                        templateUrl: 'app/endeks/modal-edr-star-error.html'
                    });
                    deferred.resolve(false);
                }
            } else {
                deferred.resolve(false);
                makeReadyForPayment(product, house, isRent);
            }
            return deferred.promise;
        }

        function buyReportFromPropertyDetailAdmin(product, house, isRent) {
            var deferred = $q.defer();
            if (product.code === 'edr-house') {

                obj.buyElectronicReport(product, house, isRent, 0, true).then(function (refresh) {
                    deferred.resolve(refresh);
                }).catch(e => {
                    deferred.reject(e);
                });
            } else if (product.code === 'edr-plot') {

                obj.buyElectronicReport(product, house, isRent, 0, true).then(function (refresh) {
                    deferred.resolve(refresh);
                }).catch(e => {
                    deferred.reject(e);
                });
            } else if (product.code === 'edr-land') {

                obj.buyElectronicReport(product, house, isRent, 0, true).then(function (refresh) {
                    deferred.resolve(refresh);
                }).catch(e => {
                    deferred.reject(e);
                });
            } else if (product.code === 'edr-commercial') {

                obj.buyElectronicReport(product, house, isRent, 0, true).then(function (refresh) {
                    deferred.resolve(refresh);
                }).catch(e => {
                    deferred.reject(e);
                });
            } else {
                deferred.resolve(false);
                makeReadyForPayment(product, house, isRent);
            }
            return deferred.promise;
        }


        function getProducts() {
            var deferred = $q.defer();
            products_factory.list().$promise.then(
                function (response) {
                    if (response) {
                        deferred.resolve({
                            result: "success",
                            data: response
                        });
                    } else {
                        deferred.reject({
                            result: "failure"
                        });
                    }
                },
                function () {
                    deferred.reject({
                        result: "failure"
                    });
                }
            );
            return deferred.promise;
        }

        function getProductsForFilter() {
            var deferred = $q.defer();
            products_factory.listForFilter().$promise.then(
                function (response) {
                    if (response) {
                        deferred.resolve({
                            result: "success",
                            data: response
                        });
                    } else {
                        deferred.reject({
                            result: "failure"
                        });
                    }
                },
                function () {
                    deferred.reject({
                        result: "failure"
                    });
                }
            );
            return deferred.promise;
        }


        function changePricesByCurrency(products, currency) {
            products.forEach((p, i) => {
                let priceObj = p.prices.find(price => price.currency === currency);

                if (priceObj) {
                    products[i].monthlyContractedPrice = priceObj.monthlyContractedPrice;
                    products[i].monthlyPrice = priceObj.monthlyPrice;
                    products[i].singlePrice = priceObj.singlePrice;
                    products[i].yearlyContractedPrice = priceObj.yearlyContractedPrice;
                    products[i].yearlyPrice = priceObj.yearlyPrice;
                }

                return products;

            });
        }
    }
})();
